import React from 'react';
import "./footer.css"
import Logo from "./images/logosvg2";
export default function Footer() {

  return ( 
    <footer className="footer">
      {/* Identidad */}
      <div className="footer-section">
        <div className='footer-empresa'>
            <div className='footer-logo'>
            <Logo/>
          </div>
          <h3 className="footer-title">Chamuscón Guatemala</h3>
        </div>
        <p>Reserva en linea tu cancha preferida</p>
      </div>

      {/* Navegación rápida */}
      <div className="footer-section">
        <h4>Navegación</h4>
        <ul className="footer-list">
          <li><a href="/" className="footer-link">Inicio</a></li>
          <li><a href="/terminos-y-condiciones" className="footer-link">Términos y condiciones</a></li>
          <li><a href="/consulta-de-reservas" className="footer-link">Consulta de reserva</a></li>
        </ul>
      </div>

      {/* Información de contacto */}
      <div className="footer-section">
        <h4>Contacto</h4>
        <p><a href="tel:+50235358461" className="footer-link">+502 3535 8461</a></p>
        <p><a href="mailto:chamuscongt@gmail.com" className="footer-link">chamuscongt@gmail.com</a></p>
        <p>Lun a Dom: 7:00 a 20:00</p>
      </div>

      {/* Redes sociales */}
      <div className="footer-section">
        <h4>Redes Sociales</h4>
        <p>
        <a href="https://www.facebook.com/share/14EUmkWNjBg/" target="_blank" rel="noreferrer" className="footer-link">Facebook</a><br />
          <a href="https://www.instagram.com/chamuscongt" target="_blank" rel="noreferrer" className="footer-link">Instagram</a><br />
          <a href="https://wa.me/50235358461" target="_blank" rel="noreferrer" className="footer-link">WhatsApp</a><br />
          <a href="https://www.tiktok.com/@chamuscon" target="_blank" rel="noreferrer" className="footer-link">TikTok</a>
        </p>
      </div>

      {/* Derechos reservados + métodos de pago */}
      <div className="footer-bottom">
        <p>© 2025 Chamuscón Guatemala. Todos los derechos reservados.</p>
      </div>
    </footer>
  )
}